module.exports = __webpack_public_path__ + "img/repeater-red.90105b2b.png";